import { api } from "../lib/api";

export const list = () => api.get("/folders").then((r) => r.data);
export const create = (payload) => api.post("/folders", payload).then((r) => r.data);
export const update = (id, payload) => api.put(`/folders/${id}`, payload).then((r) => r.data);
export const remove = (id) => api.delete(`/folders/${id}`).then((r) => r.data);
export const setAccess = (id, payload) =>
  api.put(`/folders/${id}/access`, payload).then((r) => r.data);
